import HeaderState from '../State/HeaderState'
import Action, { ActionPaymentDialog ,ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'

const actionDialogStateChanged = (oldState: HeaderState, action: Action): HeaderState => {
    return { ...oldState, paymentDialogIsOpen : (action as ActionPaymentDialog).isOpen}
}

type Process = (oldState: HeaderState, action: Action) => HeaderState

export const HeaderReducer: Reducer<HeaderState, Action> = (state: HeaderState = { paymentDialogIsOpen: false }, action: Action): HeaderState => {

    let actionMap = new Map<ActionType, Process>()

    actionMap.set(ActionType.OPEN_PAYMENT_DIALOG, actionDialogStateChanged)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


